import jQuery from 'jquery';
(function ($) {
    $(document).foundation();
})(jQuery);
